<section class="content-layout content-layout-4">
  <div class="container">
    <div class="row">
      @if (breakpoints() === "mobile") {
        <ng-container class="row">
          <div class="col-xs-12">
            @if (subTitle()) {
              <app-title [titles]="[subTitle()]" class="sub-title" />
            }
            @if (title()) {
              <app-title [titles]="[title()]" class="title" />
            }
          </div>
          <div class="items col-xs-12">
            @for (item of data().items; track item) {
              <div class="item">
                <hr class="separator" />
                @if (item.value; as title) {
                  <app-title [titles]="baseTitle() | buildTitle: { text: title, font: 'INTER' }" />
                }
                @if (item.describe; as text) {
                  <p>{{ text }}</p>
                }
              </div>
            }
          </div>
        </ng-container>
      } @else {
        <div class="col-lg-12">
          @if (subTitle()) {
            <app-title [titles]="[subTitle()]" class="sub-title" />
          }
        </div>
        <div class="col-lg-5">
          @if (title()) {
            <app-title [titles]="[title()]" class="title" />
          }
        </div>
        <div class="col-lg-6 col-lg-offset-1">
          <div class="items">
            @for (item of data().items; track item) {
              <div class="item">
                <hr class="separator" />
                @if (item.value; as title) {
                  <app-title [titles]="baseTitle() | buildTitle: { text: title }" />
                }
                @if (item.describe; as text) {
                  <p>{{ text }}</p>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
